module.exports = __webpack_public_path__ + "static/21-04-02_13-12-18_4941-cf838ac9b6f0bb88e9fbe3d1350baacc.png";